<template>
    <div>
      <v-dialog v-model="dialogtopupsaldo" persistent max-width="500">
        <v-card>
          <img class="imgtopupsaldo"  alt="topupsaldo" src="../assets/topup-saldo.png"/>
          <v-card-text class="mt-4">
            <v-tabs fixed-tabs  v-model="tab">
              <v-tab>Transfer</v-tab>
              <v-tab>Virtual Account</v-tab>
<!--              <v-tab>BITCOIN</v-tab>-->
              <v-tab-item>
                <v-text-field autofocus label="Masukan Jumlah Topup" v-model="jml"></v-text-field>
              </v-tab-item>
              <v-tab-item>
                <div class="ma-2">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-left">
                          BANK
                        </th>
                        <th class="text-left">
                          No VA
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="item in user.va"
                          :key="item.nova"
                      >
                        <td>{{ item.bank }}</td>
                        <td>{{ item.nova }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-tab-item>
<!--              <v-tab-item>-->

<!--                <div class="align-content-center text-center mt-2">-->
<!--                  Scan alamat BitCoin dibawah-->
<!--                  <img src="../assets/btcadd.png">-->
<!--                </div>-->
<!--              </v-tab-item>-->
            </v-tabs>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="0" color="red darken-1" dark @click.native="setdialogtopupsaldo(false)">Tutup</v-btn>
            <v-btn elevation="0" color="primary darken-1"  @click.native="selanjutnya">Lanjut</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogTopupSaldo',
  data: () => ({
    tab: null,
    judul: 'Tambah Saldo',
    jml: 0
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('SaldoStore', ['dialogtopupsaldo'])
  },
  methods: {
    ...mapActions('SaldoStore', ['setdialogtopupsaldo', 'setjmltopup']),
    selanjutnya () {
      if (this.jml >= 50000) {
        this.$ga.event({
          eventCategory: 'Balance',
          eventAction: 'Topupsaldo',
          eventLabel: 'TransferBank',
          eventValue: this.jml
        })
        this.setdialogtopupsaldo(false)
        this.setjmltopup(this.jml)
        this.$router.push('/tambahsaldo')
      }
    }
  }
}
</script>

<style scoped>
.imgtopupsaldo {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
